import {DxUserSession} from "./dx-user-session";
import {DxUser} from "./dx-user";
import {DxKeycloakUser} from "./dx-keycloak-user";

/**
 *  Фабрика для создания экземляров `DxUserSession` из различных потомков `DxUser`
 */
export class DxSessionFactory {

  /** Фабричный метод для созднии сессии */
  public static createUserSession(user: DxUser): DxUserSession {
    if (user instanceof DxKeycloakUser) return DxSessionFactory._createFromDxKeycloakUser(user);
    if (user instanceof DxUser) return DxSessionFactory._createFromDxUser(user)
  }

  /** Тоже по-факту дамми пример */
  private static _createFromDxUser(user: DxUser): DxUserSession {
    const session = new DxUserSession();
    session.position = user.position;
    session.name = user.fullName;
    return session;
  }

  /** Создание сессии для пользователя из keycloak */
  private static _createFromDxKeycloakUser (user: DxKeycloakUser): DxUserSession {
    const session = new DxUserSession();
    session.name = user.fullName;
    session.token = user.token;
    session.tokenExpTime = user.tokenExpTime;
    session.refreshToken = user.refreshToken;
    session.refreshTokenExpTime = user.refreshTokenExpTime;
    session.roles = user.roles;
    return session;
  }
}
